module.exports = __webpack_public_path__ + "static/media/front.696d7a92.jpg";